import APILibrary, { GenerateResource } from './APILibrary';
import { UserProfileResource } from 'util/resources/UserProfile';
import { EmployerResource } from 'util/resources/Employer';

/**
 * Relationship classes
 */
export interface UserListing {
  userProfileId?: string;
  userProfileName?: string;
  jobListingId?: string;
  roleTitle?: string;
  locationId?: string;
}

class HiringUpdateAttributes {
  id: string = null;
  foundJob: boolean = null;
  platform: string = null;
  employerId: string = null;
  employerName: string = null;
  userProfileId: string = null;
  reportedById: string = null;
  reportedByType: string = null;
  hiredUserListings: UserListing[] = null;
}

class HiringUpdateBelongsTo {
  userProfile: () => UserProfileResource = () => new UserProfileResource();
  employer: () => EmployerResource = () => new EmployerResource();
}

class HiringUpdateBelongsToPolymorphic {
  reportedBy: () => UserProfileResource | EmployerResource = () => null;
}

/**
 * Utility interfaces
 */
export interface HiringUpdateInterface
  extends HiringUpdateAttributes,
    HiringUpdateBelongsTo,
    HiringUpdateBelongsToPolymorphic {}
export interface HiringUpdateResource extends HiringUpdateInterface {}

/**
 * Resource methods
 */
export class HiringUpdateResource extends GenerateResource<HiringUpdateAttributes>({
  queryName: 'user_profile/hiring_updates',
  className: 'HiringUpdate',
  AttributesClass: HiringUpdateAttributes,
  BelongsToClasses: [
    {
      Klass: HiringUpdateBelongsTo,
    },
    {
      Klass: HiringUpdateBelongsToPolymorphic,
      options: {
        polymorphic: true,
      },
    },
  ],
}) {}

/**
 * Resource instance
 */
export const HiringUpdate = APILibrary.createResource<HiringUpdateResource>(HiringUpdateResource);
